(function () {
  function productCostcoButton() {
    console.log("Costco running");

    function createRedirectButton(url) {
      const button = document.createElement("a");
      button.href = url;
      button.target = "_blank";
      button.textContent = "You Can Order It On Costco If You're In Canada";
      button.className = "convx__redirecting-to-Costco";
      return button;
    }

    function injectStyles() {
      const style = document.createElement("style");
      style.textContent = `
            .convx__redirecting-to-Costco {
              display: inline-block;
              border: var(--btn-border-width) solid rgb(var(--btn-alt-text-color));
              outline-color: rgb(var(--btn-alt-text-color));
              outline-offset: 3px;
              background: #3071A9;
              color: white;
              margin-top: 15px;
              width: 100%;
              border-radius: var(--btn-border-radius, 0);
              padding: var(--btn-padding-y, 12px) 26px;
              text-align: center;
            }
            .convx__redirecting-to-Costco:hover {
              background: #367AAE;
            }
          `;
      document.head.appendChild(style);
    }

    function addRedirectButton(url) {
      let redirectButton = document.querySelector(".convx__redirecting-to-Costco");
      const addToCartButton = document.querySelector(".product-info__add-to-cart");
      if (addToCartButton) {
        if (!redirectButton) {
          // Create a new button if it doesn't exist
          redirectButton = createRedirectButton(url);
          addToCartButton.insertAdjacentElement("afterend", redirectButton);
        }
      }
    }

    function init() {
      if (window.location.pathname.includes("/products/keychron-q1-he-keyboard-m3-mouse-palm-rest-combo")) {
        injectStyles();
        addRedirectButton("https://www.costco.ca/keychron-q1-he-magnetic-switch-keyboard-and-m3-mouse-bundle-with-palmrest.product.4000354603.html");
      } else if (window.location.pathname.includes("/products/keychron-k10-max-keyboard-m2-mouse-palm-rest-combo")) {
        injectStyles();
        addRedirectButton("https://www.costco.ca/keychron-k10-max-mechanical-keyboard-and-m2-mouse-bundle-with-palmrest.product.4000362415.html");
      }
    }

    init();
  }

  function onDOMContentLoaded() {
    const path = location.pathname;
    const isHomePage = path == "/";
    const isProducts = path.includes("/products");
    const isCollections = path.includes("/collections") && !isProducts;
    const isCart = path == "/cart";

    if (isProducts) {
      productCostcoButton()
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
